import { browser } from '../base/vietmeet-lib';
/**
 * Returns true if VietMeet Meet is running in too old vietmeet-electron app and false otherwise.
 *
 * @returns {boolean} - True if VietMeet Meet is running in too old vietmeet-electron app and false otherwise.
 */
export function isOldVietMeetElectronApp() {
    if (!browser.isElectron()) {
        return false;
    }
    // @ts-ignore
    const match = navigator.userAgent.match(/(VietMeet)\s*\/\s*((\d+)\.[^\s]*)/);
    if (!Array.isArray(match) || match.length < 3) {
        return false;
    }
    const majorVersion = Number(match[3]);
    if (isNaN(majorVersion) || majorVersion >= 2022) {
        return false;
    }
    return true;
}
